'use client';

import { useMedia } from 'react-use';

export const useIsMobile = () => {
  const isDesktop = useMedia('(min-width: 960px)', false);

  return {
    isDesktop,
    isMobile: !isDesktop,
  };
};
